<script>
import CurrencyAPI from "../classes/API/CurrencyAPI.js";

export default {
    props: {
        price: null,
        promoPrice: null,
        oldPrice: null
    },
    mounted() {
        CurrencyAPI.info().then(result => {
            this.currency = result;
        });
    },
    computed: {
        formattedPrice() {
            let price = null;
            if (this.isPromoPrice() && this.promoPrice) {
                price = this.promoPrice;
            } else {
                price = this.price;
            }
            price = parseFloat(price);
            return new Intl.NumberFormat('pl-PL', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(price);
        },
        formattedOldPrice() {
            let oldPrice = null;
            if (this.promoPrice) {
                oldPrice = this.price;
            } else {
                oldPrice = this.oldPrice;
            }
            oldPrice = parseFloat(oldPrice);
            return new Intl.NumberFormat('pl-PL', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(oldPrice);
        },
        symbolPlacement() {
            return this.currency.symbol_placement;
        },
        symbol() {
            return this.currency.symbol;
        }
    },
    methods: {
        isPromoPrice() {
            return this.price && this.promoPrice && this.promoPrice !== this.price
                || this.price && this.oldPrice && this.oldPrice !== this.price;
        }
    },
    data() {
        return {
            currency: {}
        }
    }
}
</script>
<template>
    <span class="price-old" v-if="isPromoPrice()">
        <span v-if="symbolPlacement === 'before'" class="currency-symbol currency-symbol-before">{{ symbol }}</span>
        <span class="price-value">{{ formattedOldPrice }}</span>
        <span v-if="symbolPlacement === 'after'" class="currency-symbol currency-symbol-after">{{ symbol }}</span>
    </span>
    <span class="price">
        <span v-if="symbolPlacement === 'before'" class="currency-symbol currency-symbol-before">{{ symbol }}</span>
        <span class="price-value">{{ formattedPrice }}</span>
        <span v-if="symbolPlacement === 'after'" class="currency-symbol currency-symbol-after">{{ symbol }}</span>
    </span>
</template>
